// extracted by mini-css-extract-plugin
export default {"layout":"SectionTitleLayout_layout__eYlx8"};